export default {
  "PROFILE": "प्रोफाइल"
};